import MasterCrudPage from "../../components/MasterCrudPage";
import { serviceCategoryApi, serviceSubCategoryApi } from "../../api/masterApi";

export default function ServiceSubCategory() {
  return (
    <MasterCrudPage
      title="Sub category Master"
      description="Add sub categories under a category from Category Master."
      idKey="service_sub_category_id"
      api={serviceSubCategoryApi}
      listLabel="sub categories"
      hasImage
      imageField="service_sub_category_image"
      loadExtraOptions={async () => {
        const categories = await serviceCategoryApi.list();
        return {
          serviceCategories: categories.map((c) => ({
            value: c.service_category_id,
            label: c.service_category_name,
          })),
        };
      }}
      fields={[
        {
          name: "service_category_id",
          label: "Category",
          type: "select",
          required: true,
          optionsKey: "serviceCategories",
          placeholder: "Select Category",
        },
        {
          name: "service_sub_category_name",
          label: "Sub Category",
          type: "text",
          required: true,
          placeholder: "e.g. Residential Vastu",
        },
        {
          name: "service_sub_category_image",
          label: "Sub Category Image",
          type: "file",
        },
        {
          name: "display_style",
          label: "Display Style",
          type: "radio",
          required: true,
          defaultValue: "Square",
          options: [
            { value: "Square", label: "Square" },
            { value: "Petal", label: "Petal" },
          ],
        },
        {
          name: "sort_order",
          label: "Sort Order",
          type: "number",
          min: 0,
          step: "1",
          defaultValue: "0",
        },
        { name: "status", label: "Status", type: "checkbox" },
      ]}
      columns={[
        { key: "service_category_name", label: "Category" },
        { key: "service_sub_category_id", label: "Sub Category" },
        { key: "service_sub_category_name", label: "Sub Category" },
        { key: "display_style", label: "Display Style" },
        { key: "sort_order", label: "Sort Order" },
        { key: "status", label: "Status", type: "status" },
      ]}
    />
  );
}
